export const wide = "waxfeo3";
export const live = "l1piy320";
export const wideButton = "wj9fxdr";

require("./styles.linaria.module.css!=!../../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./styles.ts");